import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const GetWorkReqService = async (entityID,WorkReqServiceID,navigate) => {
  const accesstoken = getToken();
  if (accesstoken && entityID) {
    try {
      const response = await fetch(`${dev_baseUrl}/WorkRequirement/get?workReqServiceID=${WorkReqServiceID}&entityID=${entityID}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
          navigate(`/login`);
      } else if(response.ok && !data.isError ){
        return data.result;
      } 
      else {
        console.error('Server error:', data);
        return [];
      }
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token or EntityID is not available.');
    return { form: 'Access token is missing.' };
  }
};
